import { getSuggestionsList, getSuggestionEntry } from "../../../data/models/suggestion.model";
import { bus } from "@/main";

export default {
	name: "MindWalksPage",
	data() {
		return {
			lang: this.$route.params.lang,
			isReady: false,
			content: [],
			totalPages: null,
			currentPage: 1,
			totalEntries: null,
			suggestion: null,
			suggestionSlug: null
		}
	},
	props: {},
	created() {
		this.getContent();
		this.getSuggestion();
	},
	watch: {
		"$route": function () {
			this.getContent()
			this.getSuggestion();
		}
	},
	computed: {},
	methods: {
		getContent() {
			let contentReady = new Promise((resolve, reject) => {
				getSuggestionsList(1).then(
					content => {
						this.content = content.content;
						this.totalPages = content.totalPages;
						this.totalEntries = content.totalEntries;
						this.isReady = true;
						resolve(true)
					}
				);
			})
			Promise.all([contentReady]).then(() => {
				bus.$emit("evalColors", true);
				bus.$emit("PAGE_IS_READY", true);
			});
		},
		getMoreContent(page) {
			getSuggestionsList(1, page).then(content => {
				content.content.forEach(element => {
					this.content.push(element)
				});
				this.totalPages = content.totalPages;
				this.totalEntries = content.totalNews;
				this.currentPage++;
			});
		},
		getSuggestion() {
			this.suggestionSlug = this.$route.params.suggestion;
			if (this.suggestionSlug) {
				getSuggestionEntry(this.suggestionSlug, "slug", 1).then(
					content => {
						this.suggestion = content;
					}
				)
			}
		},
		showImage: function (event, value) {
			this.bgImage = value;
		},
		hideImage: function (value) {
			this.bgImage = null;
		},
	}
}



// WEBPACK FOOTER //
// ./src/components/pages/suggestions/suggestions.page.js